export default "__VITE_ASSET__DJg3S1Mx__"